import { createSelector } from 'reselect';

const selectRoutingPacks = (state: any) => state.routingPacks;


export const selectRoutingPacksCurrentItem = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.current);

export const selectRoutingPacksListItems = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectRoutingPacksListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRoutingPacksQueryItems = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.query);

export const selectRoutingPacksCreatedItem = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.create);

export const selectRoutingPacksUpdatedItem = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.update);

export const selectRoutingPacksReadItem = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.read);

export const selectRoutingPacksDeletedItem = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.delete);

export const selectRoutingPacksSearchedItems = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.search);

export const selectRoutingPacksItemsCount = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.count);

export const selectRoutingPacksItemsFilter = createSelector([selectRoutingPacks], (routingPacks) => routingPacks.filter);